import { required } from 'vuelidate/lib/validators'

export default {
  personIdentTyp: { required },
  wert: { required }
}



// WEBPACK FOOTER //
// ./src/validation/PersonIdent.js